import { map } from "lodash-es";
import {
  configProviderProps,
  provideGlobalConfig
} from "@vue-admin-core/components/config-provider";
import type { ConfigProviderContext } from "@vue-admin-core/components/config-provider";
import { version } from "./version";
import type { Plugin } from "vue";

const INSTALLED_KEY = Symbol("CONFIGPROVIDERINSTALLED");
export const makeInstaller = (components: Plugin[] = []) => {
  const install = (app: any, options?: ConfigProviderContext) => {
    if (app[INSTALLED_KEY]) return;

    app[INSTALLED_KEY] = true;
    components.forEach((c) => app.use(c));
    if (options) {
      map(configProviderProps, (value, key: keyof ConfigProviderContext) => {
        if (!options[key]) options[key] = value.default;
      });
      provideGlobalConfig(options, app, true);
    }
  };

  return {
    install,
    version
  };
};
